module.exports = null;


//////////////////
// WEBPACK FOOTER
// ./sources/core/ui/layout/resizer_cell.gpl.js
// module id = 12
// module chunks = 0